module.exports = __webpack_public_path__ + "img/login-logo2.93e8bdb3.png";